module.exports = __webpack_public_path__ + "static/npc-7d1aedff664332dc5ec6740c2be25adf.png";